import React from 'react';
import styled, { css } from 'styled-components';
import { Indicator, IndicatorLayoutComponentProps, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import CountUp from 'react-countup';
import { CellLabel, LinkButton, useLang } from '@shapeable/ui';
import { ExternalLinkIconGlyph } from '@shapeable/icons';

const cls = classNames('indicator-layout-badge');

// -------- Types -------->

// -------- Props -------->

export type IndicatorLayoutLinkButtonProps = IndicatorLayoutComponentProps & {
};

const IndicatorLayoutLinkButtonDefaultProps: Omit<IndicatorLayoutLinkButtonProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    width: fit-content;
    font-weight: 600;
    font-size: 1em;
    ${theme.TRANSITION('box-shadow', 'scale', 'background')};
    border-radius: 50%;

    &:hover {
      box-shadow: 0px 6px 14px rgba(210, 57, 37, 0.18);
      scale: 1.01;
    }

    &:active {
      scale: 0.99;
    }
  `,
});


// -------- Components -------->

const My = {
  Container: styled(LinkButton)<ContainerProps>`${ContainerStyles}`,
};

export const IndicatorLayoutLinkButton: Shapeable.FC<IndicatorLayoutLinkButtonProps> = (props) => {
  const componentProps = props;
  const { className, children, entity } = componentProps;

  const { result, title } = entity || {};
  const { value } = result || {};

  const t = useLang();

  return (
    <My.Container 
      className={cls.name(className)} 
      href={value || ''} 
      variant='slim'
      iconSize={18}
      borderStyle='solid'
      shape='rounded'
      icon={ExternalLinkIconGlyph}
      colors={{
        border: 'primary',
        background: 'primary',
        text: 'light',
        fill: 'light',
        hover: {
          border: '#F0A48A',
          background: '#FAE8E0',
          text: 'primary',
          fill: 'primary',
        },
      }}
    >
        {entity?.title || t('Learn More')}
      </My.Container>
  )
};

IndicatorLayoutLinkButton.defaultProps = IndicatorLayoutLinkButtonDefaultProps;
IndicatorLayoutLinkButton.cls = cls;